<template>
  <div class="page-blog">
    <vue-headful
      title="Itchyfeet - Blog"
      description="Itchyfeet Blog"
    />

    <section class="blog-section-1 container-fluid">
      <div class="d-flex text-center h-100 justify-content-center">
        <div class="my-auto w-50 text-white">
          <h1>Blog.</h1>
        </div>
      </div>
    </section>

    <section class="blog-section-2 py-5">
      <div class="container">
        <div class="col-md-12">
            <div class="card">
              <div class="row no-gutters">
                <div class="col-8">
                  <img v-if="firstPost.image" class="img-fluid" v-bind:src="firstPost.image">
                </div>
                <div class="col">
                  <div class="card-block p-2">
                    <h4 class="card-title h5 mt-2 mb-1">{{firstPost.name}}</h4>
                    <p class="mb-2">{{firstPost.shortDescription}}</p>
                    <a class="text-success pb-2" v-bind:href="firstPost.link" target="_blank">Read More →</a>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>

    <section class="blog-section-3 py-5">
      <div class="container mt-3">
        <div class="row" v-for="(blogPosts, index) in restOfPosts" v-bind:key="index">
          <div class="col-lg-4" v-for="blogPost in blogPosts" v-bind:key="blogPost.name">
            <div class="card mb-4">
              <img v-if="firstPost.image" class="card-img-top" v-bind:src="blogPost.image">
              <div class="card-body">
                <h2 class="card-title">{{blogPost.name}}</h2>
                <p>{{blogPost.shortDescription}}</p>
                <a class="text-success" v-bind:href="blogPost.link" target="_blank">Read More →</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ul class="pagination justify-content-center mb-4">
        <li class="page-item">
          <a class="btn btn-lg page-link mt-5" href="https://medium.com/@itchyfeetapp" target="_blank">View All</a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>

import {getBlogPosts} from '../../api'

export default {
  name: 'Blog',
  mounted: function () {
    if (!this.loading && !this.hasPosts) {
      this.loadPosts()
    }
  },
  data: function () {
    return {
      loading: false,
      rawPosts: false
    }
  },
  computed: {
    hasPosts: function () {
      return !this.loading === false && this.rawPosts !== false
    },
    posts: function () {
      if (!this.rawPosts) {
        return []
      }

      return this.rawPosts.map(({
        title,
        uniqueSlug,
        previewContent: {
          subtitle,
          bodyModel: {
            paragraphs
          }
        }
      }) => {
        let img = ''

        paragraphs.forEach(p => {
          if (p.name === 'previewImage') {
            img = `https://miro.medium.com/fit/c/1400/420/${p.metadata.id}`
          }
        })

        return {
          name: title,
          shortDescription: subtitle,
          link: `https://medium.com/@itchyfeetapp/${uniqueSlug}`,
          image: img
        }
      })
    },
    firstPost: function () {
      return this.posts.length > 0 ? this.posts[0] : false
    },
    restOfPosts: function () {
      return this.posts.length > 1 ? this.chunkArray(this.posts.slice(1), 3) : false
    }
  },
  methods: {
    loadPosts: function () {
      this.loading = true
      getBlogPosts().then(rawPosts => {
        this.loading = false
        this.rawPosts = Object.values(rawPosts.payload.references.Post).sort(p => p.createdAt)
      })
    },
    chunkArray: function (arr, len) {
      let chunks = []
      let i = 0
      let n = arr.length

      while (i < n) {
        chunks.push(arr.slice(i, i += len))
      }

      return chunks
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/app";
  @import "../../styles/blog";
</style>



// WEBPACK FOOTER //
// src/components/Blog/Blog.vue